module.exports = __webpack_public_path__ + "assets/img/d247-tc.svg";